// NPM imports

import moment from 'moment';

// Project imports

import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { luftGet, luftPost, luftPut, luftDelete } from '../shared/http';
import { USER_TYPES } from '../pages/Admin/shared/static-options';

// actions

const REQUEST_PLATFORM_USERS =
  'luft/admin-platform-users/REQUEST_PLATFORM_USERS';
const REQUEST_PLATFORM_USERS_SUCCESS =
  'luft/admin-platform-users/REQUEST_PLATFORM_USERS_SUCCESS';
const REQUEST_PLATFORM_USERS_FAILURE =
  'luft/admin-platform-users/REQUEST_PLATFORM_USERS_FAILURE';

const ADD_PLATFORM_USER = 'luft/admin-platform-users/ADD_PLATFORM_USER';
const ADD_PLATFORM_USER_SUCCESS =
  'luft/admin-platform-users/ADD_PLATFORM_USER_SUCCESS';
const ADD_PLATFORM_USER_FAILURE =
  'luft/admin-platform-users/ADD_PLATFORM_USER_FAILURE';
const ADD_PLATFORM_USER_CLEAR =
  'luft/admin-platform-users/ADD_PLATFORM_USER_CLEAR';

const UPDATE_PLATFORM_USER = 'luft/admin-platform-users/UPDATE_PLATFORM_USER';
const UPDATE_PLATFORM_USER_SUCCESS =
  'luft/admin-platform-users/UPDATE_PLATFORM_USER_SUCCESS';
const UPDATE_PLATFORM_USER_FAILURE =
  'luft/admin-platform-users/UPDATE_PLATFORM_USER_FAILURE';
const UPDATE_PLATFORM_USER_CLEAR =
  'luft/admin-platform-users/UPDATE_PLATFORM_USER_CLEAR';

const REMOVE_PLATFORM_USER = 'luft/admin-platform-users/REMOVE_PLATFORM_USER';
const REMOVE_PLATFORM_USER_SUCCESS =
  'luft/admin-platform-users/REMOVE_PLATFORM_USER_SUCCESS';
const REMOVE_PLATFORM_USER_FAILURE =
  'luft/admin-platform-users/REMOVE_PLATFORM_USER_FAILURE';
const REMOVE_PLATFORM_USER_CLEAR =
  'luft/admin-platform-users/REMOVE_PLATFORM_USER_CLEAR';

const BATCH_UPDATE_PLATFORM_USERS =
  'luft/admin-platform-users/BATCH_UPDATE_PLATFORM_USERS';
const BATCH_UPDATE_PLATFORM_USERS_SUCCESS =
  'luft/admin-platform-users/BATCH_UPDATE_PLATFORM_USERS_SUCCESS';
const BATCH_UPDATE_PLATFORM_USERS_FAILURE =
  'luft/admin-platform-users/BATCH_UPDATE_PLATFORM_USERS_FAILURE';

// reducer

const initialState = {
  platformUsers: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  addPlatformUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
  updatePlatformUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
  batchUpdatePlatformUsers: {
    isFetching: false,
    error: '',
    requested: '',
  },
  removePlatformUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_PLATFORM_USERS: {
      return {
        ...state,
        platformUsers: {
          ...state.platformUsers,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case REQUEST_PLATFORM_USERS_SUCCESS: {
      return {
        ...state,
        platformUsers: {
          ...state.platformUsers,
          isFetching: false,
          error: '',
          data: action.data,
        },
      };
    }

    case REQUEST_PLATFORM_USERS_FAILURE:
      return {
        ...state,
        platformUsers: {
          ...state.platformUsers,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_PLATFORM_USER: {
      return {
        ...state,
        addPlatformUser: {
          ...state.addPlatformUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case ADD_PLATFORM_USER_SUCCESS: {
      return {
        ...state,
        addPlatformUser: {
          ...state.addPlatformUser,
          isFetching: false,
          error: '',
        },
      };
    }

    case ADD_PLATFORM_USER_FAILURE:
      return {
        ...state,
        addPlatformUser: {
          ...state.addPlatformUser,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_PLATFORM_USER_CLEAR:
      return {
        ...state,
        addPlatformUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_PLATFORM_USER: {
      return {
        ...state,
        updatePlatformUser: {
          ...state.updatePlatformUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case UPDATE_PLATFORM_USER_SUCCESS: {
      return {
        ...state,
        updatePlatformUser: {
          ...state.updatePlatformUser,
          isFetching: false,
          error: '',
        },
      };
    }

    case UPDATE_PLATFORM_USER_FAILURE:
      return {
        ...state,
        updatePlatformUser: {
          ...state.updatePlatformUser,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_PLATFORM_USER_CLEAR:
      return {
        ...state,
        updatePlatformUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case REMOVE_PLATFORM_USER: {
      return {
        ...state,
        removePlatformUser: {
          ...state.removePlatformUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case REMOVE_PLATFORM_USER_SUCCESS: {
      return {
        ...state,
        removePlatformUser: {
          ...state.removePlatformUser,
          isFetching: false,
          error: '',
        },
        platformUsers: {
          ...state.platformUsers,
          data: state.platformUsers.data.filter(
            el => el.id !== action.data.userId,
          ),
        },
      };
    }

    case REMOVE_PLATFORM_USER_FAILURE:
      return {
        ...state,
        removePlatformUser: {
          ...state.removePlatformUser,
          isFetching: false,
          error: action.error,
        },
      };

    case REMOVE_PLATFORM_USER_CLEAR:
      return {
        ...state,
        removePlatformUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case BATCH_UPDATE_PLATFORM_USERS: {
      return {
        ...state,
        batchUpdatePlatformUsers: {
          ...state.batchUpdatePlatformUsers,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case BATCH_UPDATE_PLATFORM_USERS_SUCCESS: {
      return {
        ...state,
        batchUpdatePlatformUsers: {
          ...state.batchUpdatePlatformUsers,
          isFetching: false,
          error: '',
        },
      };
    }

    case BATCH_UPDATE_PLATFORM_USERS_FAILURE:
      return {
        ...state,
        batchUpdatePlatformUsers: {
          ...state.batchUpdatePlatformUsers,
          isFetching: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators
// list
function requestPlatformUsers() {
  return { type: REQUEST_PLATFORM_USERS };
}

function requestPlatformUsersSuccess(data) {
  return {
    type: REQUEST_PLATFORM_USERS_SUCCESS,
    data,
  };
}

function requestPlatformUsersFailure(error) {
  return {
    type: REQUEST_PLATFORM_USERS_FAILURE,
    error,
  };
}

// add
function addPlatformUser() {
  return { type: ADD_PLATFORM_USER };
}

function addPlatformUserSuccess(data) {
  return {
    type: ADD_PLATFORM_USER_SUCCESS,
    data,
  };
}

function addPlatformUserFailure(error) {
  return {
    type: ADD_PLATFORM_USER_FAILURE,
    error,
  };
}

export function addPlatformUserClear() {
  return { type: ADD_PLATFORM_USER_CLEAR };
}

// update
function updatePlatformUser() {
  return { type: UPDATE_PLATFORM_USER };
}

function updatePlatformUserSuccess(data) {
  return {
    type: UPDATE_PLATFORM_USER_SUCCESS,
    data,
  };
}

function updatePlatformUserFailure(error) {
  return {
    type: UPDATE_PLATFORM_USER_FAILURE,
    error,
  };
}

export function updatePlatformUserClear() {
  return { type: UPDATE_PLATFORM_USER_CLEAR };
}

// remove
function removePlatformUser() {
  return { type: REMOVE_PLATFORM_USER };
}

function removePlatformUserSuccess(data) {
  return {
    type: REMOVE_PLATFORM_USER_SUCCESS,
    data,
  };
}

function removePlatformUserFailure(error) {
  return {
    type: REMOVE_PLATFORM_USER_FAILURE,
    error,
  };
}

export function removePlatformUserClear() {
  return { type: REMOVE_PLATFORM_USER_CLEAR };
}

// batch

function batchUpdatePlatformUsers() {
  return { type: BATCH_UPDATE_PLATFORM_USERS };
}

function batchUpdatePlatformUsersSuccess(data) {
  return {
    type: BATCH_UPDATE_PLATFORM_USERS_SUCCESS,
    data,
  };
}

function batchUpdatePlatformUsersFailure(error) {
  return {
    type: BATCH_UPDATE_PLATFORM_USERS_FAILURE,
    error,
  };
}

// thunk action creators
export function fetchPlatformUsers(query) {
  return function (dispatch) {
    (async () => {
      dispatch(requestPlatformUsers());

      const params = query ? { query } : null;

      try {
        const response = await luftGet('/PlatformUser', params);
        dispatch(dispatch(requestPlatformUsersSuccess(response.data)));
      } catch (error) {
        loggedUserRequestErrorHandler(dispatch, error, requestPlatformUsersFailure(error.message));
      }
    })();
  };
}

export function fetchAddPlatformUser(
  name,
  email,
  companyId,
  divisions,
  roles,
  isCustomerService,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(addPlatformUser());

      const requestBody = {
        name,
        email,
        divisions: isCustomerService
          ? divisions.toString()
          : companyId.divisions,
        companyId: companyId ? companyId.id : null,
        roles,
        userType: isCustomerService
          ? USER_TYPES.CUSTOMER_SERVICE_USER
          : USER_TYPES.PLATFORM_USER,
      };

      try {
        const response = await luftPost('/PlatformUser', requestBody);
        dispatch(addPlatformUserSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          addPlatformUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchUpdatePlatformUser(
  id,
  name,
  email,
  companyId,
  divisions,
  roles,
  isCustomerService,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(updatePlatformUser());

      const requestBody = {
        id,
        name,
        email,
        divisions: isCustomerService
          ? divisions.toString()
          : companyId.divisions,
        companyId: companyId ? companyId.id : null,
        roles,
        userType: isCustomerService
          ? USER_TYPES.CUSTOMER_SERVICE_USER
          : USER_TYPES.PLATFORM_USER,
      };

      try {
        const response = await luftPut('/PlatformUser', requestBody);
        dispatch(updatePlatformUserSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          updatePlatformUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchBatchUpdatePlatformUsers(userDataList, roles) {
  return function (dispatch) {
    (async () => {
      dispatch(batchUpdatePlatformUsers());

      const requestBody = userDataList.map(userData => ({
        ...userData,
        roles,
      }));

      try {
        const response = await luftPut('/PlatformUser/UpdateMany', requestBody);
        dispatch(batchUpdatePlatformUsersSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          batchUpdatePlatformUsersFailure(error.message),
        );
      }
    })();
  };
}

export function fetchRemovePlatformUser(userId) {
  return function (dispatch) {
    return (async () => {
      dispatch(removePlatformUser());

      const params = { userId };

      try {
        await luftDelete('/PlatformUser', params);
        dispatch(removePlatformUserSuccess(params));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          removePlatformUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}
